import React, { useState, useEffect, useRef, useContext, forwardRef, useImperativeHandle } from "react";
import './Sidebar.scss';
import { ThemeContext } from '../contexts/themeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import axios from "axios";

const SideNav = forwardRef(({ sidebarOpen, setSidebarOpen, startNewChat, loadPreviousChat }, ref) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const sidebar = useRef(null);
  const { theme } = useContext(ThemeContext);
  const strokeColor = theme === 'dark' ? '#ececec' : '#000000';
  const [data, setData] = useState(null);
  const [selectedUUID, setSelectedUUID] = useState(null);
  
  useEffect(() => {
    if (sidebarExpanded) {
      document.querySelector("body")?.classList.add("sidebar-expanded");
    } else {
      document.querySelector("body")?.classList.remove("sidebar-expanded");
    }
  }, [sidebarExpanded]);

  useImperativeHandle(ref, () => ({
    fetchHistory
  }));

  const newChat = () => {
    startNewChat();
    fetchHistory();
  }

  useEffect(() => {
    fetchHistory();
  }, [])

  const fetchHistory = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}/chats/segmented_data`;
      const token = localStorage.getItem("stadata-token");
      const headers = {
        "Content-Type": "application/json",
        "x-access-token": token
      };
      const response = await axios.get(apiUrl, { headers });
      if (response?.status === 200) {
        if (response?.data?.length > 0 && response?.data[0].docs.length > 0) {
          let currentid = localStorage.getItem('stadata-session-type');
          if (currentid) {
            setSelectedUUID(currentid);
          } else {
            setSelectedUUID(response?.data[0].docs[0]?.uuid)
          }
        }
        if (response?.data?.length > 0) {
          setData(response?.data);
        } else {
          setData([]);
        }
      } else {
        console.error("Error:", response?.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const loadChat = async (item) => {
    try {
      setSelectedUUID(item.uuid);
      loadPreviousChat(item);
    } catch(err) {
      console.log('err', err);
    }
  }

  return (
    <>
      <div onClick={() => setSidebarOpen(!sidebarOpen)}
        className={`sidenav-main fixed inset-0 sm:translate-x-0 z-40 lg:hidden lg:z-auto transition-opacity duration-200 ${
          sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`} aria-hidden="true">
      </div>
      <div id="sidebar transition duration-150 ease-in-out" ref={sidebar}
        className={`sidenav-main pt-5 fixed flex flex-col z-40 left-0 top-0 lg:static lg:left-auto lg:top-auto lg:translate-x-0 h-screen overflow-y-scroll lg:overflow-y-auto no-scrollbar lg:w-64 w-72 lg:sidebar-expanded:w-20 shrink-0 sm:translate-x-0 px-2 py-4 transition-all duration-200 ${sidebarOpen ? "translate-x-20" : "-translate-x-72"}`}>
          <div className="flex flex-col h-full">
            <div className="space-y-5 flex-shrink-0 px-1">
              <div className={`${sidebarExpanded ? "lg:hidden nav-logo-section-center" : "block nav-logo-section"} text-xs font-base uppercase`}>
                <img src="stadata-logo.png" width="20px" alt="logoalt"></img>
                <button title="Start a new chat" className={`${sidebarExpanded ? "pen-icon mt-5" : "pen-icon"}`} onClick={newChat}>
                  <FontAwesomeIcon icon={faPenToSquare} />
                </button>
              </div>
              {data?.length === 0 && (
                <div className={`${!sidebarExpanded ? "" : "hidden"}`}>
                  <ul className="space-y-2 pt-5">
                    <li>No Chat History</li>
                  </ul>
                </div>
              )}
            </div>
            <div className={`${!sidebarExpanded ? "" : "hidden"} mt-1 overflow-y-auto scroll-smooth`}>
              {data && data.length > 0 && data.map((d, index) => (
                <div key={d?._id}>
                  <span className="pl-1 pt-7 pb-1 pb-1 list-title">{d._id}</span>
                  <ul className="nav-item">
                    {d && d.docs.map((x, index) => (
                      <li title={x?.title} key={index} onClick={() => loadChat(x)} className={`history-link transition duration-250 ease-in-out ${selectedUUID === x?.uuid && 'active-nav-link'}`}>{x?.title || 'No Title'}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="pt-1 lg:inline-flex mt-auto flex-shrink-0">
              <div className="flex-1" />
              <div className="px-3 py-2 justify-end">
                <button className="hidden md:block" onClick={() => setSidebarExpanded(!sidebarExpanded)}>
                  <span className="sr-only">Expand / collapse sidebar</span>
                  <svg className={`w-6 h-6 hidden lg:block fill-current ${!sidebarExpanded ? "rotate-0" : "rotate-180"}`} viewBox="0 0 24 24">
                    <path
                      d="M10.5 19.5L3 12M3 12L10.5 4.5M3 12H21"
                      stroke={strokeColor}
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <button className="block md:hidden" onClick={() => setSidebarOpen(!sidebarOpen)}>
                  <span className="sr-only">Expand / collapse sidebar</span>
                    <svg className={`w-6 h-6 fill-current transition duration-150 ease-in-out`} viewBox="0 0 24 24">
                      <path
                        d="M10.5 19.5L3 12M3 12L10.5 4.5M3 12H21"
                        stroke={strokeColor}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                </button>
              </div>
            </div>
          </div>
      </div>
    </>
  );
});

export default SideNav;